/**
 * Trang chính `/` — "Vận hành chiếu sáng". TK-33 bản 2 · TK-47 · TK-48 (lee 27/10 chọn THEO HẲN bản ChatGPT v06):
 *   · Đầu trang "Vận hành chiếu sáng" + dải "TOÀN HỆ THỐNG" một hàng (Tổng tủ · Trực tuyến · Mất kết nối XÁM · Tổng đèn / Tổng tuyến)
 *     — một nguồn `soTongQuan`, luật số 0.
 *   · ≥ 1200 px: cột "KHU VỰC ĐIỀU PHỐI / Tuyến & thiết bị" (cây có ô tìm) · bản đồ. < 1200: cây gập thành nút "Đổi đối tượng".
 *   · Bản đồ "KHÔNG GIAN ĐỊNH VỊ"; KHUNG ĐIỀU KHIỂN của đối tượng đang chọn NỔI trên bản đồ (≥ 900) hoặc là TẤM TRƯỢT nửa dưới (< 900).
 *     Luật thay cho "không khối nào đè bản đồ" (TK-47): vật đang chọn KHÔNG BAO GIỜ nằm dưới khung — đo bbox khung thật, `vungTuDo`
 *     + `panInside`. Dưới bản đồ: dải "ĐANG ĐỊNH VỊ · <tên>" + "Điều khiển ↗" (mở lại khung) + chip tủ.
 *   · Cây, chip, chấm bản đồ, dòng bảng đều ghi CÙNG tham số URL `?tuyen=&tu=&den=`.
 *   · Dưới: khung tuyến / toàn bộ · bảng tủ đang chọn · bảng đèn tuyến | Trung tâm sự cố (≥ 1200 px; hẹp hơn ⇒ chuông).
 *
 * 🔴 MỘT NGUỒN (phép TK-25 `GD-04` giữ câu hỏi): ô số đọc `soTongQuan()` (lib/tongquan.ts) trên CÙNG dòng `useDongHeThong()`
 *   mà cột Trung tâm sự cố và chuông đọc — "Sự cố đang mở" = tab "Đang mở" = số chuông.
 * ⛔ LUẬT SỐ 0: "—" khi chưa có số, không 0.  ⛔ MẤT KẾT NỐI XÁM (luật lee 12/10).
 */
import { useEffect, useMemo, useRef, useState } from 'react';
import L from 'leaflet';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowUpRight, Layers, Lightbulb, ListTree, LocateFixed, Maximize2, Route, Server, ServerOff } from 'lucide-react';
import { useMoPhong, useTree } from '../lib/queries';
import { ErrorBox, Modal } from '../components/ui';
import { BanDoTu, toaDoHopLe } from '../components/BanDoTu';
import { BangTu } from '../components/BangTu';
import { HopLopNema, LopDenNema, popupDemDen, useLopNema, type DenBanDo } from '../components/nema/LopDenNema';
import { useNemaBat } from '../lib/nema';
import { TrungTamSuCo, useDongHeThong } from '../components/HopVanDe';
import { soTongQuan } from '../lib/tongquan';
import { tuSo1 } from '../lib/vanHanh';
import { KhungToanBo, KhungTuyen, NutNgoTuyen } from '../components/vanhanh/KhungTuyen';
import { KhoiDieuKhien, useCoTheDoSang } from '../components/vanhanh/KhoiDieuKhien';
import { CayVanHanh } from '../components/vanhanh/CayVanHanh';
import { KhungDieuKhien, type TheKhung } from '../components/vanhanh/KhungDieuKhien';
import { NguonAcTu } from '../components/vanhanh/NguonAcTu';
import { BangDenTuyen, khoaDen } from '../components/vanhanh/BangDenTuyen';
import { tenDen } from '../lib/nemaNhan';
import { useBeRongCuaSo, useDatDoiTuong } from '../lib/doiTuongDangChon';
import { boCucVanHanh, lePanInside, vungTuDo } from '../lib/dieuKhienDoSang';
import { ODenChon } from '../components/vanhanh/ODenChon';
import { TienTrinhLenh, type ChonTienTrinh } from '../components/vanhanh/TienTrinhLenh';
import { DaiHostNema } from '../components/vanhanh/DaiHostNema';
import { useTienTrinhCacTu } from '../lib/nemaApi';
import { lenhGanNhatCuaDen, muonCuaDen } from '../lib/tienTrinhLenh';
import { useAuth } from '../lib/auth';
import '../vanhanh.css';

/**
 * Một mục của dải "Toàn hệ thống" (TK-47: thay 4 ô số to). `tri === null` ⇒ "—" xám (luật số 0). Chấm màu theo token (không emoji).
 */
/** KA-49 §4.5: chú giải 3 màu của ĐÈN (cùng màu chấm thật: `MAU_BADGE` SANG = lá · viền hổ phách đang đuổi mức · xám mất liên lạc). */
const CHU_GIAI_DEN = [{ ten: 'Đèn sáng · có số', lop: 'text-tot' }, { ten: 'Đang đuổi mức', lop: 'text-canh' }, { ten: 'Đèn mất liên lạc', lop: 'text-chu-3' }];

function OSo({ ten, nhan, tri, icon, lopIcon, lopSo = 'text-chu-1', title }: {
  ten: string; nhan: string; tri: string | null; mo?: string; icon: React.ReactNode; lopIcon: string; lopSo?: string; title?: string;
}) {
  return (
    <div className="op-o-so" data-o-so={ten} title={title}>
      <span className={`grid shrink-0 place-items-center ${lopIcon}`} aria-hidden="true">{icon}</span>
      <strong className={`tabular-nums ${tri === null ? 'text-chu-3' : lopSo}`} data-so>{tri ?? '—'}</strong>
      <small>{nhan}</small>
    </div>
  );
}

export default function DashboardPage() {
  const tree = useTree();
  /* TK-44: link "Cài đặt ban đầu" ở dòng tủ chưa cài đèn — cùng cổng vai với mục menu ấy */
  const { hasRole } = useAuth();
  const viec = useDongHeThong();
  const { data: moPhong } = useMoPhong();
  const [thamSo, datThamSo] = useSearchParams();
  const tuChon = thamSo.get('tu');
  /* TK-47 §1.5: ĐÈN đang chọn cũng sống trong URL (`?den=<cabinetId>:<addr>`) — cùng chỗ với `?tuyen=&tu=` */
  const denUrl = thamSo.get('den');
  /* Đổi mỗi lần chọn (kể cả chọn lại đúng tủ đang chọn) ⇒ bản đồ bay lại. */
  const [lanChon, setLanChon] = useState(0);
  useEffect(() => { setLanChon((n) => n + 1); }, [tuChon]);
  /* TK-38 việc 2b: tuyến đang chọn sống trong URL (`?tuyen=`), cùng chỗ với `?tu=`; chọn tủ ⇒ tuyến = tuyến của tủ ấy */
  const tuyenUrl = thamSo.get('tuyen');
  /* TK-47 (kiểm vòng 1): chọn tủ ghi CẢ ?tuyen= (tuyến của tủ) — cùng hình với chọn đèn */
  const chonTu = (id: string) => {
    const tuyen = (tree.data ?? []).find((r) => r.cabinets.some((c) => c.id === id))?.id;
    datThamSo({ ...(tuyen ? { tuyen } : {}), tu: id }); setLanChon((n) => n + 1);
  };
  const dongBang = () => datThamSo(tuyenUrl ? { tuyen: tuyenUrl } : {});
  /* TK-46 §4: phạm vi tài khoản chỉ có MỘT tuyến ⇒ chọn sẵn tuyến ấy (nút Bật/Tắt tuyến không đứng ở "Chọn tuyến") */
  useEffect(() => {
    const ds = tree.data;
    if (ds && ds.length === 1 && !tuyenUrl && !tuChon) datThamSo({ tuyen: ds[0].id }, { replace: true });
  }, [tree.data, tuyenUrl, tuChon, datThamSo]);

  /*
   * TK-31 (lee 22/10) — LỚP ĐÈN NEMA trên bản đồ, CHỈ khi máy chủ bật NEMA. Cờ tắt / chưa hỏi xong ⇒ `useLopNema([])` không gọi
   *   API nào và `BanDoTu` không nhận prop NEMA nào (cùng khung, không ô/tab/nút NEMA).
   */
  const ttNema = useNemaBat().trangThai;
  const coNema = ttNema === 'bat';
  /* vòng 2 (mục 1): ô thứ 4 là "Tổng tuyến" CHỈ khi máy chủ nói rõ không có NEMA (404). Lỗi / chưa hỏi xong ⇒ vẫn "Tổng đèn", "—". */
  const nemaTat = ttNema === 'tat';
  const lopNema = useLopNema(coNema ? (tree.data ?? []).map((r) => r.id) : []);
  const tuBam = tuChon;   // tủ đang chọn ⇒ link "Sửa vị trí đèn" (/ban-do?tu=)
  useEffect(() => { document.title = 'Vận hành — SDKD'; }, []);

  /* 🔴 MỘT NGUỒN: ô số đọc `tq`. TK-38 việc 2a (lee 23/10): Tổng tủ · Trực tuyến · Mất kết nối (XÁM) · Tổng đèn (cờ tắt ⇒ Tổng tuyến). */
  const tq = useMemo(() => soTongQuan(tree.data, viec.dong), [tree.data, viec.dong]);
  /* vòng 2: cây tuyến lỗi / chưa về ⇒ không biết có bao nhiêu tủ ⇒ không đếm được đèn ⇒ "—" (không ra 0 từ danh sách rỗng) */
  const tongDen = coNema && !lopNema.dangTai && Array.isArray(tree.data) && !tree.isError ? lopNema.den.length : null;
  /* số đèn theo tuyến (cờ NEMA bật, đã tải) — khung tuyến */
  const denTheoTuyen = useMemo(() => {
    if (!coNema || lopNema.dangTai) return null;
    const m = new Map<string, number>();
    for (const d of lopNema.den) if (d.tuyenId) m.set(d.tuyenId, (m.get(d.tuyenId) ?? 0) + 1);
    return m;
  }, [coNema, lopNema.dangTai, lopNema.den]);

  /* Thanh công cụ bản đồ (mẫu `.map-tools`). */
  const tuyenCuaTu = tuChon ? (tree.data ?? []).find((r) => r.cabinets.some((c) => c.id === tuChon))?.id ?? null : null;
  const tuyenChon = tuyenUrl ?? tuyenCuaTu ?? '';
  const rChon = tuyenChon ? (tree.data ?? []).find((x) => x.id === tuyenChon) ?? null : null;
  /* TK-38 việc 2b: bấm một tuyến (cây hoặc ô thả xuống) ⇒ bay tới TỦ SỐ 1 của tuyến (`tuSo1`); không tủ nào có toạ độ ⇒ đứng yên */
  const chonTuyen = (id: string) => { datThamSo(id ? { tuyen: id } : {}); setLanKhop((n) => n + 1); };
  /*
   * ĐÈN ĐANG CHỌN — TK-47: một tham số URL `den` (khoá `cabinetId:addr`). Chọn đèn ⇒ `?tuyen=&tu=<tủ của đèn>&den=`; bấm lại đúng
   *   đèn ở bảng ⇒ bỏ chọn. `nguonDen` chỉ để bản đồ KHÔNG bay khi người vừa bấm ngay trên chấm.
   */
  const [nguonDen, setNguonDen] = useState<'ban-do' | 'khac'>('khac');
  const chonDen = (k: string, nguon: 'ban-do' | 'khac' = 'khac') => {
    const d = lopNema.den.find((x) => khoaDen(x) === k);
    if (!d) return;
    setNguonDen(nguon);
    if (nguon !== 'ban-do' && k === denUrl) { datThamSo({ ...(d.tuyenId ? { tuyen: d.tuyenId } : {}), tu: d.cabinetId }); return; }
    datThamSo({ ...(d.tuyenId ? { tuyen: d.tuyenId } : {}), tu: d.cabinetId, den: k });
  };
  const boChonDen = () => datThamSo({ ...(tuyenChon ? { tuyen: tuyenChon } : {}), ...(tuChon ? { tu: tuChon } : {}) });
  const denDangChon = denUrl ? lopNema.den.find((d) => khoaDen(d) === denUrl) ?? null : null;
  /* TK-47 §2: bố cục theo bề rộng — một hàm thuần (`boCucVanHanh`) */
  const boCuc = boCucVanHanh(useBeRongCuaSo());
  const [moCay, setMoCay] = useState(false);
  const mapRef = useRef<L.Map | null>(null);
  /* TK-45 §2: thanh đáy — tuyến › tủ › đèn */
  useDatDoiTuong({ tuyen: rChon?.tenDayDu, tu: tuChon ? rChon?.cabinets.find((c) => c.id === tuChon)?.name : null, den: denDangChon ? tenDen(denDangChon) : null });
  const denCuaTuyen = useMemo(() => (coNema && rChon && !lopNema.dangTai ? lopNema.den.filter((d) => d.tuyenId === rChon.id) : null), [coNema, rChon, lopNema.dangTai, lopNema.den]);
  const [nenToi, setNenToi] = useState(true);
  const [hienTu, setHienTu] = useState(true);
  const [hienSuCo, setHienSuCo] = useState(true);
  const [lanKhop, setLanKhop] = useState(0);
  const tu1 = useMemo(() => (rChon ? tuSo1(rChon.cabinets.filter((c) => toaDoHopLe(c.lat, c.lng))) : null), [rChon]);
  const diemKhung = useMemo<[number, number][] | null>(() => (tu1 ? [[tu1.lat as number, tu1.lng as number]] : null), [tu1]);
  /* mở thẳng `/?tuyen=` (cây tuyến về SAU lần vẽ đầu) hoặc đổi tuyến ⇒ bay khi tủ số 1 xuất hiện / đổi */
  useEffect(() => { if (tu1) setLanKhop((n) => n + 1); }, [tu1?.id]);
  const canhBaoMo = useMemo(() => viec.dong.flatMap((d) => (d.alarm && d.muc !== 'xong' ? [d.alarm] : [])), [viec.dong]);
  const soDenTu = useMemo(() => { const m = new Map<string, number>(); for (const d of lopNema.den) m.set(d.cabinetId, (m.get(d.cabinetId) ?? 0) + 1); return m; }, [lopNema.den]);

  const banDoQs = new URLSearchParams({ ...(tuyenChon ? { tuyen: tuyenChon } : {}), ...(tuChon ? { tu: tuChon } : {}) }).toString();
  const LOP_CONG_CU = 'pointer-events-auto rounded-nut border border-vien bg-nen-0/95 shadow-[0_3px_12px_rgb(0_0_0/0.27)]';
  const thanhCongCu = (
    <div className="pointer-events-none flex w-full flex-wrap items-center gap-1.5 md:gap-2" data-o="thanh-cong-cu-ban-do">
      <select value={tuyenChon} onChange={(e) => chonTuyen(e.target.value)} aria-label="Tuyến"
        className={`${LOP_CONG_CU} max-w-[190px] px-3 py-[9px] text-xs text-chu-1 md:max-w-[260px] md:text-[13px]`}>
        <option value="">Tất cả tuyến</option>
        {(tree.data ?? []).map((r) => <option key={r.id} value={r.id}>{r.tenDayDu}</option>)}
      </select>
      <button type="button" onClick={() => setNenToi((v) => !v)} title="Đổi lớp bản đồ" aria-pressed={nenToi} data-o="lop-ban-do"
        className={`${LOP_CONG_CU} inline-flex items-center gap-2 px-2 py-2 text-xs text-chu-1 hover:bg-nen-2 md:px-3 md:text-[13px]`}>
        <Layers className="h-[17px] w-[17px]" aria-hidden="true" /><span className="hidden sm:inline">Lớp bản đồ</span>
      </button>
      <div className={`${LOP_CONG_CU} flex gap-2 p-1 text-[11px] text-chu-1 md:text-[13px]`} role="group" aria-label="Lớp hiển thị">
        <label className="flex cursor-pointer items-center gap-1 p-1"><input type="checkbox" checked={hienTu} onChange={(e) => setHienTu(e.target.checked)} className="accent-nhan" data-o="o-tu" />Tủ</label>
        {coNema && <label className="flex cursor-pointer items-center gap-1 p-1"><input type="checkbox" checked={lopNema.hien} onChange={(e) => lopNema.setHien(e.target.checked)} className="accent-nhan" data-o="o-den" />Đèn</label>}
        <label className="flex cursor-pointer items-center gap-1 p-1"><input type="checkbox" checked={hienSuCo} onChange={(e) => setHienSuCo(e.target.checked)} className="accent-nhan" data-o="o-su-co" />Sự cố</label>
      </div>
      <button type="button" onClick={() => setLanKhop((n) => n + 1)} title="Về tuyến đang chọn" aria-label="Về tuyến đang chọn" data-o="dinh-vi-tuyen"
        className={`${LOP_CONG_CU} inline-flex items-center px-2 py-2 text-chu-1 hover:bg-nen-2 md:px-3`}>
        <LocateFixed className="h-[17px] w-[17px]" aria-hidden="true" />
      </button>
      {/* TK-44 §4: ⤢ BẢN ĐỒ TUYẾN (chỉ xem) mang tuyến + tủ đang chọn; trang ấy có "← Về Vận hành" trả về đúng `?tuyen=&tu=` */}
      <Link to={`/ban-do${banDoQs ? `?${banDoQs}` : ''}`} title="Bản đồ tuyến" aria-label="Bản đồ tuyến" data-o="toan-man-hinh"
        className={`${LOP_CONG_CU} ml-auto inline-flex items-center px-2 py-2 text-chu-1 hover:bg-nen-2 md:px-3`}>
        <Maximize2 className="h-[17px] w-[17px]" aria-hidden="true" />
      </Link>
    </div>
  );

  const cayVanHanh = (
    <CayVanHanh cay={tree.data ?? []} den={coNema ? lopNema.den : []} tuyenChon={tuyenChon || null} tuChon={tuChon} denChon={denUrl}
      onChonTuyen={(id) => { chonTuyen(id); setMoCay(false); }} onChonTu={(id) => { chonTu(id); setMoCay(false); }}
      onChonDen={(d: DenBanDo) => { chonDen(khoaDen(d)); setMoCay(false); }} tieuDe={boCuc === 'ba-cot'} />
  );

  /*
   * KHUNG ĐIỀU KHIỂN — TK-48 §2. Mở khi chạm đèn / tủ (mọi cỡ) hoặc chọn tuyến (màn ≥ 900); "Điều khiển ↗" mở lại khi đã đóng.
   *   Thẻ Độ sáng: `KhoiDieuKhien` (VIEWER ⇒ không có thẻ này). Thẻ Nguồn AC theo ngữ cảnh: tủ (hoặc tủ của đèn) ⇒ 3 ngõ của tủ;
   *   chỉ tuyến ⇒ bật / tắt cả tuyến. Mọi lệnh hỏi xác nhận.
   */
  const kieuKhung: 'noi' | 'truot' = boCuc === 'xep-doc' ? 'truot' : 'noi';
  const [moKhung, setMoKhung] = useState(boCuc !== 'xep-doc');
  const [the, setThe] = useState<TheKhung>('do-sang');
  useEffect(() => {
    if (!(denUrl || tuChon)) return;
    setMoKhung(true); setThe('do-sang');
    /* < 900: tấm trượt che nửa dưới màn ⇒ đưa bản đồ lên sát thanh trên để phần còn thấy đủ chỗ cho vật đang chọn (không bắt người cuộn) */
    if (kieuKhung === 'truot') {
      const el = document.getElementById('ban-do-tu');
      if (el) window.scrollTo({ top: Math.max(0, el.getBoundingClientRect().top + window.scrollY - 70) });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [denUrl, tuChon]);
  useEffect(() => { if (tuyenChon && kieuKhung === 'noi') setMoKhung(true); }, [tuyenChon, kieuKhung]);
  const coTheDoSang = useCoTheDoSang(rChon?.id ?? null);
  const tuCuaKhung = denDangChon?.cabinetId ?? tuChon;
  const tuKhung = tuCuaKhung ? rChon?.cabinets.find((c) => c.id === tuCuaKhung) ?? null : null;
  const tenKhung = denDangChon ? tenDen(denDangChon) : tuKhung?.name ?? rChon?.tenDayDu ?? '';
  const loaiKhung = denDangChon ? 'Đèn' : tuKhung ? 'Tủ' : 'Tuyến';
  /* KA-49 §4.3–4.4: dữ liệu tiến trình lệnh của các tủ CÓ ĐÈN trong tuyến đang chọn — khối Tiến trình + cột Muốn / Trạng thái */
  const tuCoDen = useMemo(() => (coNema && rChon ? rChon.cabinets.filter((c) => (soDenTu.get(c.id) ?? 0) > 0) : []), [coNema, rChon, soDenTu]);
  const tienTrinh = useTienTrinhCacTu(tuCoDen.map((c) => c.id));
  const chonTT: ChonTienTrinh | null = denDangChon ? { loai: 'den', den: denDangChon }
    : tuCuaKhung ? { loai: 'tu', id: tuCuaKhung, ten: tuKhung?.name ?? 'Tủ' }
      : rChon ? { loai: 'tuyen', tu: tuCoDen.map((c) => ({ id: c.id, name: c.name })) } : null;
  const theDim = coNema && rChon && !lopNema.dangTai && coTheDoSang
    ? <>
        <KhoiDieuKhien r={rChon} tuChon={tuChon} den={denDangChon} denCuaTuyen={denCuaTuyen ?? []} nhom={lopNema.nhom} tuNema={lopNema.tu} />
        {chonTT && <TienTrinhLenh chon={chonTT} duLieu={tienTrinh} denCuaTuyen={denCuaTuyen ?? []} />}
      </>
    : null;
  const theAc = tuCuaKhung ? <NguonAcTu key={tuCuaKhung} cabinetId={tuCuaKhung} /> : rChon ? <div className="op-nguon-ac"><NutNgoTuyen r={rChon} /></div> : null;
  const coKhung = moKhung && !!rChon;

  /* vật đang chọn không bao giờ dưới khung: đo bbox khung THẬT mỗi lần khung đổi cỡ / đối tượng đổi, rồi panInside vào vùng tự do */
  const khungEl = useRef<HTMLElement | null>(null);
  const [lanDo, setLanDo] = useState(0);
  const [caoKhung, setCaoKhung] = useState(0);
  useEffect(() => {
    const el = khungEl.current; if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => { setLanDo((n) => n + 1); setCaoKhung(el.getBoundingClientRect().height); });
    ro.observe(el); return () => ro.disconnect();
  }, [coKhung, kieuKhung]);
  const tuToaDo = tuKhung && toaDoHopLe(tuKhung.lat, tuKhung.lng) ? { lat: tuKhung.lat as number, lng: tuKhung.lng as number } : null;
  const viTri = denDangChon?.pos ?? tuToaDo;
  useEffect(() => {
    const m = mapRef.current; if (!m || !viTri) return;
    /* chờ cú bay của bản đồ (chọn tủ: flyTo 0,6 s) xong rồi mới chỉnh */
    const t = window.setTimeout(() => {
      const b = m.getContainer().getBoundingClientRect();
      const k = coKhung ? khungEl.current?.getBoundingClientRect() ?? null : null;
      const ban = { x: b.x, y: b.y, w: b.width, h: b.height };
      const vung = vungTuDo(ban, k ? { x: k.x, y: k.y, w: k.width, h: k.height } : null, kieuKhung, window.innerHeight);
      m.panInside(L.latLng(viTri.lat, viTri.lng), { ...lePanInside(ban, vung), animate: true });
    }, 750);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [denUrl, tuChon, viTri?.lat, viTri?.lng, coKhung, kieuKhung, lanDo]);

  const tenDinhVi = denDangChon ? tenDen(denDangChon) : tuKhung?.name ?? rChon?.tenDayDu ?? null;
  /* KA-49 §4.2: lệnh dim gần nhất của đèn đang chọn — vạch trên đồ thị P 30 phút + ô "Dim đèn báo" vàng khi lệch */
  const lenhDen = useMemo(() => {
    if (!denDangChon) return null;
    const l = lenhGanNhatCuaDen(tienTrinh.get(denDangChon.cabinetId)?.lenh ?? [], denDangChon.addr);
    return l && l.kind === 'dim' ? { luc: l.issuedAt, muc: l.level } : null;
  }, [denDangChon, tienTrinh]);
  /* KA-49 §4.5: đèn "đang đuổi mức" (lệnh dim gần nhất còn chờ đèn báo) — viền hổ phách trên bản đồ */
  const duoiMuc = useMemo(() => {
    const s = new Set<string>();
    for (const d of denCuaTuyen ?? []) { const tt = tienTrinh.get(d.cabinetId); if (tt && muonCuaDen(tt.lenh, d.addr, tt.now)?.ket === 'CHO') s.add(khoaDen(d)); }
    return s;
  }, [denCuaTuyen, tienTrinh]);
  /* KA-49 §4.1: dải host — tủ đang chọn (nếu có đèn), không thì mọi tủ có đèn của tuyến */
  const tuDaiHost = tuCuaKhung ? tuCoDen.filter((c) => c.id === tuCuaKhung) : tuCoDen;

  return (
    <div className="flow-ops" data-trang-chinh data-bo-cuc={boCuc}
      style={kieuKhung === 'truot' && coKhung ? { paddingBottom: caoKhung + 16 } : undefined}>
      {(tree.isError || viec.loi) && <div className="mb-3"><ErrorBox xam error={tree.error ?? new Error('Không tải được danh sách sự cố')} onRetry={() => void tree.refetch()} /></div>}

      <header className="op-dau-trang"><h1>Vận hành<span>chiếu sáng</span></h1></header>

      {/* DẢI "TOÀN HỆ THỐNG" — một hàng, một nguồn `tq` */}
      <div data-vung="tong-quan" className="op-dai-so" data-so-o={4}>
        <span className="op-kicker op-nhan-dai">TOÀN HỆ THỐNG</span>
        <OSo ten="tong-tu" nhan="Tổng tủ" tri={tq ? String(tq.tong) : null}
          icon={<Server className="h-3.5 w-3.5" />} lopIcon="text-nhan" />
        <OSo ten="truc-tuyen" nhan="Trực tuyến" tri={tq ? String(tq.online) : null}
          icon={<span className="h-2 w-2 rounded-full bg-tot" />} lopIcon="" />
        {/* mất kết nối XÁM — không đỏ (luật lee 12/10) */}
        <OSo ten="mat-ket-noi" nhan="Mất kết nối" tri={tq ? String(tq.tong - tq.online) : null} lopSo="text-chu-2"
          icon={<ServerOff className="h-3.5 w-3.5" />} lopIcon="text-chu-3" />
        {!nemaTat
          ? <OSo ten="tong-den" nhan="Tổng đèn" tri={tongDen === null ? null : String(tongDen)}
              icon={<Lightbulb className="h-3.5 w-3.5" />} lopIcon="text-nhan" />
          : <OSo ten="tong-tuyen" nhan="Tổng tuyến" tri={tq ? String(tq.soTuyen) : null}
              icon={<Route className="h-3.5 w-3.5" />} lopIcon="text-nhan" />}
      </div>

      {/* < 1200: cây gập — thanh "KHU VỰC ĐIỀU PHỐI" + nút "Đổi đối tượng" */}
      {boCuc !== 'ba-cot' && (
        <div className="op-cay-gap">
          <div className="min-w-0"><span className="op-kicker">KHU VỰC ĐIỀU PHỐI</span><strong>Tuyến & thiết bị</strong></div>
          <span className="op-dem">{tree.data?.length ?? '—'}</span>
          <button type="button" onClick={() => setMoCay(true)} data-o="doi-doi-tuong" className="op-nut-phu op-nut-doi">
            <ListTree className="h-4 w-4" aria-hidden="true" />Đổi đối tượng
          </button>
        </div>
      )}

      <div data-vung="hang-chinh" className="op-khong-gian">
        {boCuc === 'ba-cot' && <div className="op-cot-cay" data-o="cot-cay">{cayVanHanh}</div>}
        <section className="op-cot-ban-do" data-o="cot-ban-do" aria-label="Không gian định vị">
          <header className="op-dau-ban-do">
            <div className="min-w-0"><span className="op-kicker">KHÔNG GIAN ĐỊNH VỊ</span><h2 title={rChon?.tenDayDu}>{rChon?.tenDayDu ?? 'Tất cả tuyến'}</h2></div>
            <span className="op-so-tu">{rChon ? `${rChon.cabinets.length} tủ` : `${tree.data?.length ?? '—'} tuyến`}</span>
          </header>
          {tuDaiHost.map((c) => <DaiHostNema key={c.id} cabinetId={c.id} ten={c.name} gon={tuDaiHost.length === 1 && !!tuCuaKhung} />)}
          {/* BẢN ĐỒ — khung điều khiển nổi bên trong (≥ 900); vật đang chọn được dời ra ngoài bbox khung */}
          <div className="op-khung-ban-do" id="ban-do-tu" data-o="the-ban-do">
            <BanDoTu cay={tree.data} canhBao={canhBaoMo} caoLop="h-full" tranKhung diemKhung={diemKhung} lanKhop={lanKhop}
              tuChon={tuChon} lanChon={lanChon} hienTu={hienTu} hienSuCo={hienSuCo} nenToi={nenToi} thanhCongCu={thanhCongCu}
              chuGiaiThem={coNema ? CHU_GIAI_DEN : undefined}
              ghiChuDuoi={moPhong?.bat === true ? 'Vị trí thiết bị giả lập · Không dùng để định vị ngoài hiện trường' : undefined}
              lopThem={coNema ? <LopDenNema st={lopNema} tuChon={null} noiBat={denUrl} onChonDen={(k) => chonDen(k, 'ban-do')} bayNoiBat={nguonDen !== 'ban-do'} duoiMuc={duoiMuc} /> : undefined}
              hopTrai={coNema ? <HopLopNema st={lopNema} cheDo="tong-quan" tuChon={tuBam} /> : undefined}
              popupTu={coNema ? popupDemDen(lopNema) : undefined}
              onChonTu={chonTu} mapRef={mapRef} moPopupKhiChon={false} />
            {coKhung && kieuKhung === 'noi' && (
              <KhungDieuKhien kieu="noi" ten={tenKhung} loai={loaiKhung} thuoc={denDangChon ? tuKhung?.name : null} onDong={() => setMoKhung(false)}
                theDim={theDim} theAc={theAc} the={the} setThe={setThe} khungRef={khungEl}
                thongSo={denDangChon ? { ten: tenDen(denDangChon), node: <ODenChon d={denDangChon} lenh={lenhDen} /> } : null} />
            )}
          </div>
          {/* ĐANG ĐỊNH VỊ — tên đối tượng + "Điều khiển ↗" (mở lại khung) */}
          <div className="op-dang-dinh-vi" data-o="dang-dinh-vi">
            <LocateFixed className="h-4 w-4 shrink-0 text-nhan" aria-hidden="true" />
            <div className="min-w-0 flex-1"><span className="op-kicker">ĐANG ĐỊNH VỊ</span><strong title={tenDinhVi ?? undefined}>{tenDinhVi ?? '—'}</strong></div>
            {tuKhung && !denDangChon && <span className={tuKhung.status === 'ONLINE' ? 'op-tt-on' : 'op-tt-tat'}>{tuKhung.status === 'ONLINE' ? 'Trực tuyến' : 'Mất kết nối'}</span>}
            {rChon && (
              <button type="button" className="op-nut-phu op-mo-khung" aria-pressed={coKhung} data-o="mo-khung"
                onClick={() => { setMoKhung(true); if (kieuKhung === 'noi') document.getElementById('ban-do-tu')?.scrollIntoView({ block: 'nearest' }); }}>
                Điều khiển<ArrowUpRight className="h-[14px] w-[14px]" aria-hidden="true" />
              </button>
            )}
          </div>
          {/* CHIP TỦ của tuyến đang chọn — tên · số đèn · chấm trạng thái (lá = trực tuyến, XÁM = mất kết nối) */}
          {rChon && rChon.cabinets.length > 0 && (
            <div className="op-chip-tu" data-o="chip-tu">
              {rChon.cabinets.map((c) => {
                const on = c.status === 'ONLINE';
                return (
                  <button key={c.id} type="button" onClick={() => chonTu(c.id)} aria-pressed={c.id === tuChon} data-chip-tu={c.id} title={c.name}>
                    <Server className="h-[15px] w-[15px] shrink-0" aria-hidden="true" />
                    <span className="min-w-0 truncate font-medium">{c.name}</span>
                    {coNema && <span className="shrink-0 tabular-nums text-chu-3">{soDenTu.get(c.id) ?? 0} đèn</span>}
                    <span className={`h-2 w-2 shrink-0 rounded-full ${on ? 'bg-tot' : 'bg-chu-3'}`} aria-hidden="true" />
                  </button>
                );
              })}
            </div>
          )}
        </section>
      </div>

      {/* TẤM TRƯỢT (< 900) — nổi nửa dưới màn, bật lên ngay khi chạm đèn / tủ */}
      {coKhung && kieuKhung === 'truot' && (
        <KhungDieuKhien kieu="truot" ten={tenKhung} loai={loaiKhung} thuoc={denDangChon ? tuKhung?.name : null} onDong={() => setMoKhung(false)}
          theDim={theDim} theAc={theAc} the={the} setThe={setThe} khungRef={khungEl}
          thongSo={denDangChon ? { ten: tenDen(denDangChon), node: <ODenChon d={denDangChon} lenh={lenhDen} /> } : null} />
      )}

      {/* DƯỚI: khung tuyến / toàn bộ · bảng tủ đang chọn · bảng đèn tuyến | Trung tâm sự cố (≥ 1200 px) */}
      <div className="grid grid-cols-[minmax(0,1fr)] gap-2.5 min-[1200px]:grid-cols-[minmax(0,1fr)_320px] op-luoi-duoi" data-vung="luoi-van-hanh">
        <div className="flex min-w-0 flex-col gap-3">
          {rChon
            ? <KhungTuyen r={rChon} coNema={coNema} soDen={denTheoTuyen?.get(rChon.id) ?? null} chuaCoViTri={!tu1} den={denCuaTuyen} tuChon={tuChon} onChonTu={chonTu} tuNema={coNema && !lopNema.dangTai ? lopNema.tu : null} />
            : <KhungToanBo cay={tree.isError ? null : tree.data ?? null} coNema={coNema} den={coNema && !lopNema.dangTai && !tree.isError ? lopNema.den : null} />}
          {/* TỦ ĐANG CHỌN — bảng rút gọn (ngõ ra, 3 pha, lịch…), đóng được */}
          {tuChon && <div data-vung="khung-tu"><BangTu key={tuChon} cabinetId={tuChon} onDong={dongBang} /></div>}
          {coNema && rChon && (
            <BangDenTuyen den={denCuaTuyen ?? []} noiBat={denUrl} onChonDen={(k) => chonDen(k)}
              muon={(d) => { const tt = tienTrinh.get(d.cabinetId); return tt ? muonCuaDen(tt.lenh, d.addr, tt.now) : undefined; }}
              tuChuaCai={lopNema.dangTai ? [] : lopNema.tu.filter((t) => t.soDen === 0 && rChon.cabinets.some((c) => c.id === t.id))} lienKetCai={hasRole('ADMIN')} />
          )}
        </div>
        {/* TRUNG TÂM SỰ CỐ — màn ≥ 1200 px; hẹp hơn ⇒ chuông mở ngăn kéo */}
        <aside className="hidden min-h-0 rounded-the border border-vien min-[1200px]:flex min-[1200px]:max-h-[720px]" aria-label="Trung tâm sự cố">
          <TrungTamSuCo onDinhVi={chonTu} className="flex-1" />
        </aside>
      </div>

      {/* NGĂN KÉO "Đổi đối tượng" (< 1200) — cây Tuyến & thiết bị */}
      <Modal open={moCay && boCuc !== 'ba-cot'} onClose={() => setMoCay(false)} title="Tuyến & thiết bị" hoiKhiDong={false}>
        <div className="h-[60vh]">{cayVanHanh}</div>
      </Modal>
    </div>
  );
}
